export default __webpack_public_path__ + "static/media/arrow-back-black-icon.ebae457b.svg";